<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch('tryAutoLogin');}
};
</script>

<style lang="scss">
#app {
  @import "assets/style/css/bootstrap.min.css";
  @import "assets/style/css/app.min.css";
  @import "assets/style/css/custom.min.css";
  @import "assets/style/css/flags.css";
  @import "assets/style/fontawesome/css/all.css";
}
</style>
